import React from 'react';
import userEvent from '@testing-library/user-event';
import { getByText, render, waitFor } from '@testing-library/react';
import { ActionMenu } from './ActionMenu';
import { BodyText } from '../BodyText';
import { Button } from '../Button';

describe('ActionMenu', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('uncontrolled: should open nested onClick', async () => {
		const user = userEvent.setup();
		const { getByTestId } = render(
			<ActionMenu
				trigger={({ toggle }) => (
					<Button data-testid="trigger-button" onClick={toggle}>
						Open Menu
					</Button>
				)}
			>
				<ActionMenu
					data-testid="first-item"
					direction="rb"
					trigger={({ toggle }) => (
						<ActionMenu.Item
							data-testid="nest-trigger-button"
							cascading
							onClick={toggle}
						>
							Menu 01
						</ActionMenu.Item>
					)}
				>
					<ActionMenu.Item data-testid="nested-menu-01">
						Nested Menu 01
					</ActionMenu.Item>
					<ActionMenu.Item>Nested Menu 02</ActionMenu.Item>
				</ActionMenu>
				<ActionMenu.Item>Menu 02</ActionMenu.Item>
			</ActionMenu>
		);
		await user.click(getByTestId('trigger-button'));
		expect(getByTestId('first-item')).toBeTruthy();
		await user.click(getByTestId('nest-trigger-button'));
		expect(getByTestId('nested-menu-01')).toBeTruthy();
	});

	it('should pass through data automation attributes', async () => {
		const { container, baseElement } = render(
			<ActionMenu open>
				<ActionMenu.Group
					label="Text"
					data-auto-sel="automation-selector"
				>
					<ActionMenu.Item icon="phone_android">
						<BodyText subdued size="xsmall">
							Monica’s cell
						</BodyText>
						(555) 123-4567
					</ActionMenu.Item>
				</ActionMenu.Group>
			</ActionMenu>
		);

		/**
		 * NOTE: Using "baseElement" instead of "container" because
		 *       ActionMenu's children are rendered in a portal
		 */

		await waitFor(() => {
			expect(
				getByText(baseElement, 'Monica', { exact: false })
			).toBeInTheDocument();
		});

		const nonPortalElement = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);
		const portalElement = baseElement.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(nonPortalElement).toBeNull();
		expect(portalElement).not.toBeNull();
	});
});
